import LOGO from "../images/FlintTropics.png";

export const Team__FlintTropics = {
  name: "Flint Tropics",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#00AEEF",
  teamJerseyColor: "#F4A300",

  // Stats
  gamesWon: 2,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 27 + 28 + 39,
  goalsScoredAgainst: 32 + 27 + 13,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
